"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
require("./DataTableCollapse.css");
var UIProps_1 = require("../../UIProps");
var classnames_1 = __importDefault(require("classnames"));
var gsap_1 = require("gsap/dist/gsap");
var DataTable_1 = require("../DataTable/DataTable");
var useDebounceWindowResize_1 = require("../../../hooks/useDebounceWindowResize");
function DataTableCollapse(_a) {
    var _b = _a.collapseLevel, collapseLevel = _b === void 0 ? 0 : _b, props = __rest(_a, ["collapseLevel"]);
    var el = react_1.useRef(null);
    var _c = __read(react_1.useState(false), 2), expanded = _c[0], setExpanded = _c[1];
    react_1.useEffect(function () {
        if (props.expanded !== undefined)
            setExpanded(props.expanded);
    }, [props.expanded]);
    useDebounceWindowResize_1.useDebounceWindowResize(100, function () {
        if (expanded)
            bodyExpand();
        else
            bodyContract();
    }, [expanded]);
    react_1.useEffect(function () {
        if (expanded)
            bodyExpand();
        else
            bodyContract();
    }, [expanded]);
    react_1.useEffect(function () {
        var mask = el.current;
        if (mask)
            mask.style.height = '0px'; //initally transition from 0 height
    }, []);
    function bodyContract() {
        var mask = el.current;
        if (!mask)
            return;
        setTimeout(function () {
            var firstColumn = mask.getElementsByTagName('td')[0];
            var height = firstColumn.offsetHeight;
            gsap_1.gsap.to(mask, { duration: 0.3, height: height, ease: 'power2.inOut' });
        }, 0);
    }
    function bodyExpand() {
        var mask = el.current;
        if (mask) {
            setTimeout(function () {
                gsap_1.gsap.to(mask, {
                    duration: 0.3,
                    height: mask.scrollHeight,
                    ease: 'power2.inOut',
                    onComplete: function () {
                        //after transition, let css take over to becom responsive
                        mask.removeAttribute('style');
                    },
                });
            }, 0);
        }
    }
    function onToggle(e) {
        setExpanded(function (prevState) { return !prevState; });
        if (props.onToggle) {
            props.onToggle(!expanded, e);
        }
    }
    return (React.createElement("div", __assign({}, UIProps_1.setUIProps(props), { className: classnames_1.default('DataTableCollapse', props.className, {
            'DataTableCollapse-expanded': expanded,
        }), ref: el }),
        React.createElement(DataTable_1.DataTable, { caption: props.caption, headerCells: props.headerCells, cells: props.cells, showHeader: false, cellNullPlaceholder: props.cellNullPlaceholder, collapseLevel: collapseLevel || 1, _onCollapseClick: onToggle, expandAll: props.expanded, onAnyCollapseClick: props.onAnyCollapseClick })));
}
exports.DataTableCollapse = DataTableCollapse;
